import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
  selector: 'shared-domain-app-distribution',
  templateUrl: './distribution.html',
  styleUrls: ['./distribution.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButtonToggleGroup, MatButtonToggle, MatCheckbox]
})
export class DistributionSection {
  formattedAccess = input<string>('');
  distributionDetails = input<
    | {
        name: string;
        appleMinimumVersion: string;
        androidMinimumVersion: string;
      }[]
    | []
  >();

  companionAppDetails = computed(() => {
    return this.distributionDetails() ?? [];
  });
}
